var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorldLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2912 20.3636C6.81438 20.0016 3.30566 16.2574 3.30566 11.691C3.30566 6.89792 7.19483 3 11.9967 3C16.4366 3 20.0903 6.32773 20.6147 10.6236",
    stroke: "#0069B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2167 10.8046C15.1895 10.0632 15.1262 9.34896 15.027 8.67076C14.5745 5.36055 13.3904 3 11.997 3C10.6134 3 9.41947 5.36055 8.96799 8.67076C8.83177 9.6107 8.75977 10.6236 8.75977 11.691C8.75977 12.7584 8.83177 13.7801 8.96799 14.72C9.28422 17.0173 10.2611 19.2329 11.2916 20.3636",
    stroke: "#0069B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30566 11.7014H11.6036",
    stroke: "#0069B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3364 20.9991C16.7993 20.9991 13.9785 18.7163 13.9785 16.3265C13.9785 14.472 15.4818 12.9688 17.3364 12.9688C19.191 12.9688 20.6943 14.472 20.6943 16.3265C20.6943 18.7163 17.8735 20.9991 17.3364 20.9991Z",
    stroke: "#0069B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3113 16.2404H17.357",
    stroke: "#0069B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldLocation);
export default __webpack_public_path__ + "static/media/WorldLocation.42e2ecfa91507b457fb20205002b703b.svg";
export { ForwardRef as ReactComponent };